import 'aframe'
import React, { Component } from 'react'
class CamaraView extends Component {
  render () {
    const { position, huds, rotacion } = this.props
    return (
      <a-entity id='rig' rotation={'-20 0 0'}>
        <a-camera
          position={position}
          rotation={rotacion}
          wasd-controls='acceleration:1000; fly:true'
          cursor-visible='true'
          cursor-scale='2'
          cursor-opacity='0.5'
          cursor='rayOrigin: mouse'
        >
          {huds}
        </a-camera>
      </a-entity>
    )
  }
}

export default CamaraView
